import { useState, useEffect } from 'react';

const slides = [
  {
    bg: 'https://static.readdy.ai/image/b38d0475ce589291eceb67661996448f/795a27b4741a05c68c0d563c980b2776.jpeg',
    badge: 'Especialista em Brasília, DF',
    title: 'Venda ou Alugue Seu Imóvel com Quem Conhece Brasília',
    subtitle: 'Mais de 9 anos de experiência no mercado imobiliário. Avaliação gratuita, divulgação premium e resultado garantido.',
  },
  {
    bg: 'https://static.readdy.ai/image/b38d0475ce589291eceb67661996448f/2e2a507098a5ea7be31ed8cee55ceaf8.jpeg',
    badge: 'Avaliação 100% Gratuita',
    title: 'Descubra o Valor Real do Seu Imóvel em Brasília',
    subtitle: 'Análise de mercado completa, sem compromisso. Saiba quanto vale seu imóvel e como vendê-lo pelo melhor preço.',
  },
  {
    bg: 'https://static.readdy.ai/image/b38d0475ce589291eceb67661996448f/d82e3bac61bf639af165ecd01fb470ef.jpeg',
    badge: 'Resultados Comprovados',
    title: 'Seu Imóvel Vendido ou Alugado no Menor Tempo',
    subtitle: 'Estratégia de divulgação nos principais portais, redes sociais e nossa carteira exclusiva de compradores e locatários.',
  },
];

const whatsappLink = "https://wa.me/5511922305730?text=Olá%2C%20Daniel!%20Tenho%20um%20imóvel%20em%20Brasília%20e%20gostaria%20de%20uma%20avaliação%20gratuita.";
const danielPhoto = "https://static.readdy.ai/image/b38d0475ce589291eceb67661996448f/2a2558c7aa812b59f3632681c7e8edfc.png";

const HeroSlider = () => {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      goTo((current + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [current]);

  const goTo = (index: number) => {
    if (animating) return;
    setAnimating(true);
    setTimeout(() => {
      setCurrent(index);
      setAnimating(false);
    }, 400);
  };

  const slide = slides[current];

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background */}
      <div
        className={`absolute inset-0 transition-opacity duration-700 ${animating ? 'opacity-0' : 'opacity-100'}`}
        style={{ backgroundImage: `url(${slide.bg})`, backgroundSize: 'cover', backgroundPosition: 'center top' }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/50 to-black/30" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />

      {/* Content */}
      <div className="relative z-10 w-full">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center min-h-screen py-32">
            {/* Text */}
            <div className={`transition-all duration-700 ${animating ? 'opacity-0 translate-y-4' : 'opacity-100 translate-y-0'}`}>
              <span className="inline-flex items-center gap-2 bg-teal-500/20 border border-teal-400/40 text-teal-300 px-4 py-2 rounded-full text-sm font-semibold mb-6 backdrop-blur-sm">
                <i className="ri-map-pin-2-fill"></i>
                {slide.badge}
              </span>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
                {slide.title}
              </h1>
              <p className="text-lg text-white/85 mb-10 leading-relaxed max-w-xl">
                {slide.subtitle}
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-10">
                <a
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-3 bg-teal-500 hover:bg-teal-400 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-fill text-2xl"></i>
                  Avaliação Gratuita
                </a>
                <a
                  href="#formulario"
                  className="inline-flex items-center justify-center gap-3 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all border border-white/30 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-file-list-3-line text-xl"></i>
                  Quero Cadastrar Meu Imóvel
                </a>
              </div>

              {/* Trust badges */}
              <div className="flex flex-wrap gap-4">
                {[
                  { icon: 'ri-shield-check-fill', text: 'Avaliação Gratuita' },
                  { icon: 'ri-time-fill', text: 'Resposta em 24h' },
                  { icon: 'ri-award-fill', text: '9+ Anos de Experiência' },
                ].map((badge, i) => (
                  <div key={i} className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2">
                    <i className={`${badge.icon} text-teal-400`}></i>
                    <span className="text-white text-sm font-medium">{badge.text}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Daniel Photo */}
            <div className="hidden lg:flex justify-center items-end">
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="relative group cursor-pointer"
              >
                <div className="absolute -inset-6 bg-teal-500/20 rounded-full blur-3xl group-hover:bg-teal-400/30 transition-all" />
                <img
                  src={danielPhoto}
                  alt="Daniel Carvalho - Especialista Imobiliário em Brasília"
                  className="relative w-80 h-auto object-contain drop-shadow-2xl group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 bg-white text-teal-700 px-5 py-2.5 rounded-full shadow-2xl flex items-center gap-2 group-hover:scale-110 transition-transform whitespace-nowrap">
                  <i className="ri-whatsapp-fill text-lg text-green-500"></i>
                  <span className="font-bold text-sm">Falar com Daniel</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Slider dots */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-3 z-20">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className={`transition-all duration-300 rounded-full cursor-pointer ${i === current ? 'w-8 h-3 bg-teal-400' : 'w-3 h-3 bg-white/40 hover:bg-white/70'}`}
          />
        ))}
      </div>

      {/* Logo link to home */}
      <div className="absolute top-6 left-1/2 -translate-x-1/2 z-20">
        <a href="/">
          <img
            src="https://static.readdy.ai/image/b38d0475ce589291eceb67661996448f/3c37db76e3e907da977a289ded40f172.png"
            alt="Daniel Carvalho Imobiliário"
            className="h-14 w-auto drop-shadow-lg"
          />
        </a>
      </div>
    </section>
  );
};

export default HeroSlider;
